module.exports = __webpack_public_path__ + "static/media/logo_header_page.46d2ae89.png";